module.exports = __webpack_public_path__ + "static/media/crab.44da640f.jpg";